import { MediaPreviewDialog } from '@/components/plate-ui/image-preview';
import { ImagePlugin, MediaEmbedPlugin, VideoPlugin } from '@platejs/media/react';
import { ImageElement } from 'components/plate-ui/image-element';
import { MediaEmbedElement } from 'components/plate-ui/media-embed-element';
import { VideoElement } from 'components/plate-ui/media-video-element';

export const MediaKit = [
  ImagePlugin.configure({
    options: { disableUploadInsert: true },
    render: { afterEditable: MediaPreviewDialog, node: ImageElement },
  }),
  MediaEmbedPlugin.withComponent(MediaEmbedElement),
  VideoPlugin.withComponent(VideoElement),
];
